import mainImageHome from "../images/main-image-home.jpg";
import mainImageHomeCroppedTablet from "../images/main-image-home-cropped-tablet.jpg";
import mainImageHomeCroppedMobile from "../images/main-image-home-cropped-mobile.jpg";

import mainImageSection1CroppedMobile from "../images/main-image-1-section-cropped-mobile.jpg";
import mainImageSection1Croppedtablet from "../images/main-image-1-section-cropped-tablet.jpg";
import mainImageSection1 from "../images/main-image-1-section.jpg";

import mainImageSection2CroppedMobile from "../images/main-image-2-section-cropped-mobile.jpg";
import mainImageSection2Croppedtablet from "../images/main-image-2-section-cropped-tablet.jpg";
import mainImageSection2 from "../images/main-image-2-section.jpg";

import mainImageSection6CroppedMobile from "../images/main-image-6-section-cropped-mobile.jpg";
import mainImageSection6Croppedtablet from "../images/main-image-6-section-cropped-tablet.jpg";
import mainImageSection6 from "../images/main-image-6-section.jpg";

import mainImageSection7CroppedMobile from "../images/main-image-7-section-cropped-mobile.jpg";
import mainImageSection7Croppedtablet from "../images/main-image-7-section-cropped-tablet.jpg";
import mainImageSection7 from "../images/main-image-7-section.jpg";

import mainImageSection8CroppedMobile from "../images/main-image-8-section-cropped-mobile.jpg";
import mainImageSection8Croppedtablet from "../images/main-image-8-section-cropped-tablet.jpg";
import mainImageSection8 from "../images/main-image-8-section.jpg";

import mainImageSection9CroppedMobile from "../images/main-image-9-section-cropped-mobile.jpg";
import mainImageSection9Croppedtablet from "../images/main-image-9-section-cropped-tablet.jpg";
import mainImageSection9 from "../images/main-image-9-section.jpg";

import whiteBackground from "../images/white-background.jpg";

import plusSignIcon from "../images/plus-sign.png";
import minusSignIcon from "../images/minus-sign.png";

// Business Review Icons
import secondaryHen from "../images/secondary-circle-hen.svg";
import secondaryCashBox from "../images/secondary-cash-box.svg";
import secondaryRevenue from "../images/revenues-secondary.svg";
import secondaryHandCash from "../images/secondary-hand-cash.svg";
import secondaryHenPack from "../images/secondary-hen-pack.svg";
import secondaryRestaurant from "../images/secondary-restaurant.svg";

// Paragraph Images
import paragraphImage1 from "../images/paragraph-image-1.jpg";
import paragraphImage2 from "../images/paragraph-image-2.jpg";
import paragraphImage3 from "../images/paragraph-image-3.jpg";
import paragraphImage4 from "../images/paragraph-image-4.jpg";
import paragraphImage5 from "../images/paragraph-image-5.jpg";
import paragraphImage6 from "../images/paragraph-image-6.jpg";
import paragraphImage7 from "../images/the-sandwich.png";
import paragraphImage8 from "../images/paragraph-image-8.jpg";
import paragraphImage9 from "../images/paragraph-image-9.png";

import facebookIcon from "../images/facebook.svg";
import twitterIcon from "../images/twitter.svg";
import linkedinIcon from "../images/linkedin.svg";
import instagramIcon from "../images/instagram.svg";

const homeImages = [
  mainImageHomeCroppedMobile,
  mainImageHomeCroppedTablet,
  mainImageHome,
];

const mainImagesSection1 = [
  mainImageSection1CroppedMobile,
  mainImageSection1Croppedtablet,
  mainImageSection1,
];

const mainImagesSection2 = [
  mainImageSection2CroppedMobile,
  mainImageSection2Croppedtablet,
  mainImageSection2,
];

const mainImagesSection3 = [whiteBackground, whiteBackground, whiteBackground];
const mainImagesSection4 = [whiteBackground, whiteBackground, whiteBackground];
const mainImagesSection5 = [whiteBackground, whiteBackground, whiteBackground];

const mainImagesSection6 = [
  mainImageSection6CroppedMobile,
  mainImageSection6Croppedtablet,
  mainImageSection6,
];

const mainImagesSection7 = [
  mainImageSection7CroppedMobile,
  mainImageSection7Croppedtablet,
  mainImageSection7,
];

const mainImagesSection8 = [
  mainImageSection8CroppedMobile,
  mainImageSection8Croppedtablet,
  mainImageSection8,
];

const mainImagesSection9 = [
  mainImageSection9CroppedMobile,
  mainImageSection9Croppedtablet,
  mainImageSection9,
];

const mainImages = [
  homeImages,
  mainImagesSection1,
  mainImagesSection2,
  mainImagesSection3,
  mainImagesSection4,
  mainImagesSection5,
  mainImagesSection6,
  mainImagesSection7,
  mainImagesSection8,
  mainImagesSection9,
];

export const getPreloadedImage = (sectionNumber) => {
  return mainImages[sectionNumber];
};

export const generalIcons = [plusSignIcon, minusSignIcon];

const whiteBackgroundSections = [
  false,
  false,
  false,
  true,
  true,
  true,
  false,
  false,
  false,
  false,
];
const greenBackgroundContents = [2];

export const businessReviewIcons = [
  [secondaryHen, secondaryCashBox],
  [secondaryRevenue, secondaryHandCash],
  [secondaryHenPack, secondaryHenPack],
  [secondaryHen, secondaryRestaurant],
];

export const paragraphImages = [
  paragraphImage1,
  paragraphImage2,
  paragraphImage3,
  paragraphImage4,
  paragraphImage5,
  paragraphImage6,
  paragraphImage7,
  paragraphImage8,
  paragraphImage9,
];

export const whiteBackgroundsMainSection = (index) =>
  whiteBackgroundSections[index];

export const greenBackgroundContent = (index) =>
  greenBackgroundContents.includes(index);

export const socialIcons = [
  facebookIcon,
  twitterIcon,
  linkedinIcon,
  instagramIcon,
];
